import z from "zod";

/**
 * Réponse du point d'interrogation de paiement CinetPay.
 *
 * Compatible avec les deux formats :
 *  - v1 (API actuelle) : { code: 200, status: "OK", details: { status, ... } }
 *  - v2 (historique)   : { code: "00", message, data: { status, payment_date, ... } }
 */
const dataSchema = z.object({
  amount: z.string().optional(),
  currency: z.string().optional(),
  status: z.string().optional(),
  payment_method: z.string().optional(),
  description: z.string().optional(),
  metadata: z.record(z.any()).nullable().optional(),
  operator_id: z.string().nullable().optional(),
  payment_date: z.string().optional(),
  fund_availability_date: z.string().optional(),
  transaction_id: z.string().optional(),
  merchant_transaction_id: z.string().optional(),
});

const detailsSchema = z.object({
  code: z.union([z.string(), z.number()]).optional(),
  status: z.string().optional(),
  message: z.string().optional(),
  must_be_redirected: z.boolean().optional(),
});

const cinetpayWebhook = z.object({
  // v1 : numérique (200, 201, ...) ; v2 : chaîne ("00", "662", ...)
  code: z.union([z.string(), z.number()]).optional(),
  status: z.string().optional(),
  message: z.string().optional(),
  data: dataSchema.optional(),
  details: detailsSchema.optional(),
  merchant_transaction_id: z.string().optional(),
  transaction_id: z.string().optional(),
  payment_token: z.string().optional(),
  payment_url: z.string().optional(),
  api_response_id: z.string().optional(),
});

export type CinetpayWebhook = z.infer<typeof cinetpayWebhook>;
